import { useSubscription } from '@rta/rta-blueprint-library';

import { Controller } from '@context';
import { lang } from '@lang';
import { useDesign } from '@hooks';
import { Feature, FeatureHoookParams } from '..';

type CountertopFeatureParams = FeatureHoookParams;
export const useShowCountertopFeature = (_params: CountertopFeatureParams = {}): Feature<boolean> => {
	const [controller] = useDesign<Controller, { options: { showCountertops: boolean }}>();

	useSubscription(controller, false, [['layer-option-countertop', '*']]);

	const controllerSupportsFeature = (controller?.options?.showCountertops ?? null) !== null;
	const showLayer = controller?.options?.showCountertops ?? true;

	const tooltip = (() => {
		const showHide = showLayer ? lang.layer.tooltip.hide : lang.layer.tooltip.show;
		return `${showHide} ${lang.layer.label.countertops} ${lang.layer.layer}`;
	})();

	return {
		name: 'showCountertop',
		label: lang.layer.label.countertops,
		shortcut: '',
		tooltip,
		icon: (props = {}) => <></>,
		disabled: !controllerSupportsFeature,
		value: showLayer,
		hidden: false,
		handler: () => {
			if (controller) {
				controller.options.showCountertops = !showLayer;
			}
		}
	};
};
